import { IApiError } from '@/models/apiError.model';
import { IDocument } from '@/models/documentsSettings.model';
import { DocumentSourceEnum } from '@/models/documents.model';

export const DOC_SETTINGS_SLICE_NAME = 'documentsSettings';

type TDocument = Record<DocumentSourceEnum, Array<IDocument & { createId?: string }>>;

export interface DocumentsSettingsState {
  documents: TDocument | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: DocumentsSettingsState = {
  documents: null,
  isLoading: false,
  error: null,
};
